import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: 'root'
})
export class UserService {

 public apiURL: string = environment.apiURL;
  public siteUrl: string = environment.siteUrl;
  public stripeKey: string = environment.stripeKey;
  public mapsApiKey: string = environment.mapsKey;

  renew_membership = false;
  membershiNewMembers = false;
  
  clubDetails;
  club_subscription
  jwttoken:string;
  public user_id:string;

  multiClubs: boolean;
  public club_name = "connectMyClub";
  public club_colors;
  club_logo
  primary_color;
  primary_color_rgb;
  secondary_color;
  secondary_color_rgb;
  tertiary_color;
  tertiary_color_rgb;
    
  userDetails = [];
  subject: any;



  public isAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public canTimeEvents: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public hasAssociations: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  public isUpdateAvailable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showMembershipForm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isRunLeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public inAppSessions: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private newRoute: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public groupCancelled: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public basketUpdated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public walletUpdated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public trainingWalletLive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public sideBarMenu: BehaviorSubject<Array<any>> =  new BehaviorSubject<any>(['blank']); 
  public readySteady: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public readySteady$ = this.readySteady.asObservable();

  public newAnnouncement: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public newMessageBoard: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public newDM: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public newGroupMsg: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public lastCommsCheck: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public message_board_comment_update: BehaviorSubject<Array<number>> = new BehaviorSubject<[]>(null); 
  public training_group_update: BehaviorSubject<number> = new BehaviorSubject<number>(null); 
  public training_group_location_update: BehaviorSubject<Array<any>> = new BehaviorSubject<[]>(null); 
  public newOffer: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public newComp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public eventsCount: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public eventsCount$ = this.eventsCount.asObservable();
  public avatar: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public avatar$ = this.avatar.asObservable();
  public userChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public clubLogo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public clubLogo$ = this.clubLogo.asObservable();

  public clubSubscription:  BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); 

  public showUserPinInput: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public multiClubMember: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public multiClubMember$ = this.multiClubMember.asObservable();

  public clubID: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public clubID$ = this.clubID.asObservable();
  public clubName:  BehaviorSubject<any> = new BehaviorSubject<any>("connectMyClub");
  public clubName$ = this.clubName.asObservable();

  public unreadNotifications: BehaviorSubject<Array<any>> = new BehaviorSubject<[]>(null); 
  public unreadNotifications$ = this.unreadNotifications.asObservable();

  public streetHarassmentLocation: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public streetHarassmentLocation$ = this.streetHarassmentLocation.asObservable();

  cmcDetails = {'id':0,
                'name':'connectMyClub',
                'readySteady':'Ready, steady...',
                'subscription':false,
                'statusBarColor':'#ff7800',
                'statusBarText': 'dark'
    };



  public clubDetailsSubscription:  BehaviorSubject<Array<{}>> =  new BehaviorSubject<Array<{}>>([this.cmcDetails]); 

  constructor( public storage: StorageService,
    private router: Router ) { 

       //this.fetchAvatar();
  }
setThemeColors(primary: string, primaryRgb: string, secondary: string, secondaryRgb: string, tertiary: string, tertiaryRgb: string) {
  const root = document.documentElement;

  // Fallback for invalid tertiary
  if (!tertiary || !/^#([0-9A-F]{3}){1,2}$/i.test(tertiary)) {
    tertiary = primary;
    tertiaryRgb = primaryRgb;
  }

  root.style.setProperty('--ion-color-primary', primary);
  root.style.setProperty('--ion-color-primary-rgb', primaryRgb);
  root.style.setProperty('--ion-color-primary-contrast', secondary);
  root.style.setProperty('--ion-color-primary-contrast-rgb', secondaryRgb);
  root.style.setProperty('--ion-color-primary-shade', primary);
  root.style.setProperty('--ion-color-primary-tint', primary);

  root.style.setProperty('--ion-color-secondary', secondary);
  root.style.setProperty('--ion-color-secondary-rgb', secondaryRgb);
  root.style.setProperty('--ion-color-secondary-contrast', tertiary);
  root.style.setProperty('--ion-color-secondary-contrast-rgb', tertiaryRgb);
  root.style.setProperty('--ion-color-secondary-shade', secondary);
  root.style.setProperty('--ion-color-secondary-tint', secondary);


  root.style.setProperty('--ion-color-tertiary', tertiary);
  root.style.setProperty('--ion-color-tertiary-rgb', tertiaryRgb);
  root.style.setProperty('--ion-color-tertiary-contrast', secondary);
  root.style.setProperty('--ion-color-tertiary-contrast-rgb', secondaryRgb);
  root.style.setProperty('--ion-color-tertiary-shade', tertiary);
  root.style.setProperty('--ion-color-tertiary-tint', tertiary);


  // Debug
  //console.log('Computed tertiary:', getComputedStyle(root).getPropertyValue('--ion-color-tertiary'));
}


public updateUnreadNotifications(route) {

  // Get the current value
const current = this.unreadNotifications.getValue();


if (!current) { return; } // Ensure current is defined
// Find and update the item for the current route, or add it if not present

const idx = current.findIndex(n => n.route === route);

if (idx > -1) {
  // Update existing
  current[idx].unread = false;
} else {
  // Add new
  current.push({ route, unread: false });
}

// Emit the updated array
this.unreadNotifications.next([...current]);

}


  /* SET TRUE IF USER IS A CLUB LEADER */
  updateRunLeaderStatus(data): void {
    this.isRunLeader.next(data);
  }
  getRunLeaderStatus(): Observable<boolean> {
    return this.isRunLeader;
  }

  /* SET TRUE IF A NEW ROUTE HAS BEEN CREATED */
  newRouteAdded(data): void {
    this.newRoute.next(data);
  }
  getNewRouteAdded(): Observable<boolean> {
    return this.newRoute;
  }


  
async getUser() {

        let multiClubs = this.storage.getString('multiClubs').then((data: any) => {
                  //console.log(data)
                  if (data && data.value == '1') {
                      this.multiClubMember.next(true);
                }else {
                      this.multiClubMember.next(false);
                  } 

              });


    let user;
             await this.storage.getObject('clubDetails').then((data: any) => {

              if (data) {

   this.clubDetails = data;

                 // console.log("Club Details",data)
          

                // set colours as early as possible
/**/
              let primary_color = this.clubDetails['colors']['primary'];
              let primary_color_rgb = this.clubDetails['colors']['primary_rgb'];
               let secondary_color = this.clubDetails['colors']['secondary'];
               let secondary_color_rgb = this.clubDetails['colors']['secondary_rgb'];
               let tertiary_color = this.clubDetails['colors']['tertiary'];
               let tertiary_color_rgb = this.clubDetails['colors']['tertiary_rgb'];

               if (!tertiary_color) {
                  tertiary_color = primary_color;
                  tertiary_color_rgb = primary_color_rgb;
                }
          
                  this.setThemeColors(
                    primary_color,
                    primary_color_rgb,
                    secondary_color,
                    secondary_color_rgb,
                    tertiary_color,
                    tertiary_color_rgb
                  );
             
             

                user = data;

                this.user_id = this.clubDetails['user_id'];

            //  alert("USER ID: " + this.user_id)
                
                let subscription = this.clubDetails['club_subscription'];

                this.clubSubscription.next(subscription)

                let timestamp = Date.now()
                
                let avatar = this.apiURL+'avatars/'+this.user_id+'.png?'+timestamp
                this.avatar.next(avatar)
                this.userDetails['avatar'] = avatar

                this.jwttoken = this.clubDetails['jwttoken'];


                this.storage.setString('jwttoken', this.jwttoken);
                
                this.multiClubs = this.clubDetails['multiClubs'];
                
                this.clubID.next(this.clubDetails['club_id']);
                this.club_name = this.clubDetails['club_name'];  
                this.clubName.next(this.club_name);


                this.club_logo = this.siteUrl+'club_logo/' + this.clubID
                this.clubLogo.next(this.club_logo);

                this.club_colors = this.clubDetails['colors']['color1'];
 
                this.userDetails['user_id'] = this.user_id.toString();
                this.userDetails['club_id'] = this.clubID.toString();
                this.userDetails['jwttoken'] = this.jwttoken;
                this.userDetails['multiClubs'] = this.multiClubs;

            


               let sidebar = []

               if(this.clubDetails.sidebar){
                sidebar = this.clubDetails.sidebar
               }

              this.sideBarMenu.next(sidebar);
           


 let cmcDetails = [];

  cmcDetails['id'] = this.clubID
  cmcDetails['name'] = this.club_name
  cmcDetails['readySteady'] = this.clubDetails.ready_steady || 'Ready, steady...';
  this.readySteady.next(this.clubDetails.ready_steady)
  cmcDetails['subscription'] = subscription
  cmcDetails['statusBarColor'] = this.primary_color
  cmcDetails['statusBarText'] = this.clubDetails['colors']['status_bar']

 this.clubDetailsSubscription.next(cmcDetails)
                  
               /* check if membership form needs to be shown */

               this.membershiNewMembers = this.clubDetails['membership_new_members']
     // ////console.log(this.router.url);
      let membership_form_completed = this.clubDetails['membership_form_completed']
                if( this.membershiNewMembers == true && membership_form_completed == false){
              

               //  ////console.log(this.router.url);
                  let pageURL = this.router.url
                  this.showMembershipForm.next(true);
                  let passURLS = ["/app/tabs/my-details-account","/app/tabs/my-details-personal","/app/tabs/my-details-ice","/app/tabs/code-of-conduct","/app/tabs/user-settings","/app/tabs/about-licences","/app/tabs/about-terms","/app/tabs/about-privacy","/app/tabs/switch-clubs"];

                  if( pageURL.includes("club-subscription") ){
                    passURLS.push(pageURL)
                  }
//////console.log(this.router.url)
                  if( !passURLS.includes(this.router.url) ){
 this.router.navigate(['app/tabs/membership'], { replaceUrl: true });
                  }

                  
                  
                }/**/
 
              }
            });
        return user; 
    
}






}

